exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Recurring_formItem_1i2XI{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;width:100%;position:relative}.Recurring_formItem_1i2XI.Recurring__oneLine_18pdA{width:-webkit-calc(50% - 10px);width:calc(50% - 10px)}", ""]);

// exports
exports.locals = {
	"formItem": "Recurring_formItem_1i2XI",
	"_oneLine": "Recurring__oneLine_18pdA"
};